import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Button, Card, Col, Row, Spin } from 'antd';
import fulfilmentframe from '../../../assets/images/fulfilment-assistant-frame.svg'
import './completion-booking-chart.scss';
import { t } from "i18next";
import { BrandColors, BrandDarkColors } from "../../../constants/brand";
import { useIsDarkMode } from "../../../common/theme-mode/theme-mode";

const CompletionBookingChart = ({ data }) => {
    const isDarkMode = useIsDarkMode(); // SVG chart colours are props, not CSS
    const ink = isDarkMode ? BrandDarkColors.ink : '#000';

    const [completionBookingChartData, setCompletionBookingChartData] = useState([])
    const [isloading, setLoading] = useState(true)
    useEffect(() => {
        if (data?.lastSevenDaysBookedInquiry) {

            const formattedData = data.lastSevenDaysBookedInquiry.map(item => {
                const date = new Date(item.date);
                const day = date.getDate().toString().padStart(2, '0');
                return {
                    day,
                    Bookings: item.count
                };
            });
            setCompletionBookingChartData(formattedData);
        }
        setLoading(false)
    }, [data]);
    // const data1 = [
    //     { day: '01', bookings: 5 },
    //     { day: '02', bookings: 7 },
    //     { day: '03', bookings: 4 },
    //     { day: '04', bookings: 11 },
    //     { day: '05', bookings: 7 },
    //     { day: '06', bookings: 4 },
    //     { day: '07', bookings: 11 },
    // ];

    return (
        <>
            {
                (isloading) ?
                    <div className="loading">
                        <Spin style={{ marginLeft: "50%", marginTop: "10%" }} />
                    </div>
                    :
                    <Card className="last-seven-days-dashboard">
                        <h2>{t("FULLFILLMENT_BOOKING")}</h2>
                        <div className="chart-container">
                            <ResponsiveContainer width="100%" height={300}>
                                <LineChart
                                    data={completionBookingChartData}
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 10
                                    }}
                                >
                                    <CartesianGrid
                                        strokeDasharray="3 3"
                                        vertical={false}
                                        stroke={isDarkMode ? BrandDarkColors.line : "#eee"}
                                    />
                                    <XAxis
                                        dataKey="day"
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fill: isDarkMode ? BrandDarkColors.subtle : '#999' }}
                                    />
                                    <YAxis
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fill: isDarkMode ? BrandDarkColors.subtle : '#999' }}
                                        domain={[0, 'dataMax + 5']}
                                        ticks={[0, 5, 10, 15, 20]}
                                    />
                                    <Tooltip
                                        contentStyle={{
                                            background: isDarkMode ? BrandDarkColors.surface : '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                        }}
                                    />
                                    <Line
                                        type="monotone"
                                        dataKey="Bookings"
                                        stroke={isDarkMode ? BrandDarkColors.primaryHover : BrandColors.primary}
                                        strokeWidth={2}
                                        dot={{
                                            fill: ink,
                                            stroke: ink,
                                            strokeWidth: 2,
                                            r: 4
                                        }}
                                        activeDot={{
                                            fill: ink,
                                            stroke: ink,
                                            strokeWidth: 2,
                                            r: 6
                                        }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </Card>}
            {/* <Row className='need-assistance-container'>
                <Col className='written-col' span={16}>
                    <Row >{t("HOME_NEED_ASSIST")}?</Row>
                    <Row>{t("HOME_NEED_ASSIST_MSG")}</Row>
                    <Row><Button className='connect-btn'>{t("HOME_CONNECT_MSG")}</Button></Row>
                </Col>
                <Col className='img-col'>
                    <img src={fulfilmentframe} alt='ff' />
                </Col>
            </Row> */}
        </>
    );
};

export default CompletionBookingChart;